module.exports = __webpack_public_path__ + "static/note-4-906a82f4a2f18e1cb9bafd06014a87ec.jpg";